import DataTable from '../../../../shared/components/patterns/DataTable';
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from '../../../../shared/assets/AppIcons';
import { Badge } from '@/shared/ui/badge';
import { StatusPill } from '@/shared/components/patterns';
const FILTERS = [
  {
    value: 'all',
    label: 'Tutti',
  },
  {
    value: 'task',
    label: 'Task',
  },
  {
    value: 'payments',
    label: 'Pagamenti/Fatture',
  },
  {
    value: 'expenses',
    label: 'Spese',
  },
];
function getStatusLabel(status) {
  return String(status || '—').replace(/_/g, ' ');
}
function formatDate(dateString) {
  if (!dateString) return '—';
  return new Date(dateString).toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
export default function OverdueOperationalView({
  items = [],
  activeType = 'all',
  onTypeChange,
  onOpenTask,
  accountingStatus = 'idle',
  accountingError = '',
}) {
  const visibleItems = activeType === 'all' ? items : items.filter((item) => item.type === activeType);
  const accountingDegraded =
    accountingStatus === 'module_disabled' ||
    accountingStatus === 'tenant_database_unavailable' ||
    accountingStatus === 'auth_required' ||
    accountingStatus === 'unavailable';
  return (
    <section className="assignments-overdue-view">
      <div className="assignments-section-card__header">
        <div>
          <h2 className="assignments-section-card__title">Vista operativa - In ritardo</h2>
          <p className="assignments-section-card__description">
            Elementi con scadenza passata e stato non completato, saldato o chiuso.
          </p>
        </div>
        <Badge variant="outline">{visibleItems.length} elementi</Badge>
      </div>

      <div className="assignments-overdue-view__filters" aria-label="Filtri tipologia ritardi">
        {FILTERS.map((filter) => (
          <button
            key={filter.value}
            type="button"
            className={activeType === filter.value ? 'is-active' : ''}
            onClick={() => onTypeChange(filter.value)}
          >
            {filter.label}
          </button>
        ))}
      </div>

      {accountingDegraded ? (
        <div className="assignments-overdue-view__warning">
          <AlertTriangle size={16} aria-hidden="true" />
          <span>
            {accountingError ||
              'Dati accounting non disponibili: ritardi incassi e spese in stato degradato.'}
          </span>
        </div>
      ) : null}

      {visibleItems.length ? (
        <div className="assignments-overdue-view__table-wrap">
          <DataTable
            ariaLabel="Elementi in ritardo"
            rows={visibleItems}
            columns={[
              {
                id: 'type',
                header: 'Tipo',
                render: (item) => {
                  return <>{item.typeLabel}</>;
                },
              },
              {
                id: 'title',
                header: 'Descrizione',
                render: (item) => {
                  return <>{item.title}</>;
                },
              },
              {
                id: 'dueDate',
                header: 'Scadenza',
                render: (item) => {
                  return <>{formatDate(item.dueDate)}</>;
                },
              },
              {
                id: 'status',
                header: 'Stato',
                render: (item) => {
                  return (
                    <>
                      <StatusPill label={getStatusLabel(item.status)} tone="review" />
                    </>
                  );
                },
              },
              {
                id: 'actions',
                header: 'Azione',
                render: (item) => {
                  const isTask = item.type === 'task';
                  const openTask = () => {
                    if (isTask) onOpenTask?.(item.raw?.id);
                  };
                  return (
                    <>
                      {isTask ? (
                        <button
                          type="button"
                          className="assignments-overdue-view__open"
                          onClick={(event) => {
                            event.stopPropagation();
                            openTask();
                          }}
                        >
                          Apri
                        </button>
                      ) : (
                        <Link to={item.route}>Apri</Link>
                      )}
                    </>
                  );
                },
              },
            ]}
            getRowProps={(item) => {
              const isTask = item.type === 'task';
              const openTask = () => {
                if (isTask) onOpenTask?.(item.raw?.id);
              };
              return {
                tabIndex: isTask ? 0 : undefined,
                'aria-haspopup': isTask ? 'dialog' : undefined,
                'aria-keyshortcuts': isTask ? 'Enter Space' : undefined,
                'aria-label': isTask ? `Apri dettagli task: ${item.title}` : undefined,
                onClick: isTask ? openTask : undefined,
                onKeyDown: isTask
                  ? (event) => {
                      if (
                        event.target === event.currentTarget &&
                        (event.key === 'Enter' || event.key === ' ')
                      ) {
                        event.preventDefault();
                        openTask();
                      }
                    }
                  : undefined,
              };
            }}
          />
        </div>
      ) : (
        <div className="assignments-team-dialog__empty">
          <strong>Nessun elemento in ritardo</strong>
          <span>Non ci sono elementi aperti scaduti per il filtro selezionato.</span>
        </div>
      )}
    </section>
  );
}
